import { render, staticRenderFns } from "./NpsPopup.vue?vue&type=template&id=fc79346c"
import script from "./NpsPopup.vue?vue&type=script&lang=js"
export * from "./NpsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc79346c')) {
      api.createRecord('fc79346c', component.options)
    } else {
      api.reload('fc79346c', component.options)
    }
    module.hot.accept("./NpsPopup.vue?vue&type=template&id=fc79346c", function () {
      api.rerender('fc79346c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/nps-popup/NpsPopup.vue"
export default component.exports